var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 23.75c.69 0 1.25.56 1.25 1.25v.017a1.25 1.25 0 0 1-2.5 0V25c0-.69.56-1.25 1.25-1.25M31.25 20a1.25 1.25 0 1 0-2.5 0v.017a1.25 1.25 0 0 0 2.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.45 4.116a1.25 1.25 0 0 1 1.767 0L20 9.9l5.783-5.783a1.25 1.25 0 1 1 1.767 1.768l-4.532 4.532h8.649A4.584 4.584 0 0 1 36.25 15v15a4.583 4.583 0 0 1-4.583 4.583H8.333A4.583 4.583 0 0 1 3.75 30V15a4.584 4.584 0 0 1 4.583-4.584h8.649l-4.533-4.532a1.25 1.25 0 0 1 0-1.768m13.8 27.967h5.417A2.083 2.083 0 0 0 33.75 30V15a2.083 2.083 0 0 0-2.083-2.084H26.25zm-2.5-19.166v19.166H8.333A2.083 2.083 0 0 1 6.25 30V15a2.083 2.083 0 0 1 2.083-2.084H23.75",
    clipRule: "evenodd"
  })));
};
export default SvgTv;